<template>
    <div class="g pop-up-inner">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            :caption="content.caption || $t('site.noun.month')"
            :minorCaption="content.minorCaption"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div class="g">
                    <cpDatePicker
                        type="month"
                        :errorStatus="errors.has('month')"
                        :errorMsg="errors.first('month')"
                        :dayRestriction="dayRestriction"
                        v-model="month"
                        v-validate="'required'"
                        :hideLabel="true"
                        name="month"
                        ref="month"
                    ></cpDatePicker>
                </div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </div>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdBtnList from '@/components/mdBtnList'
    import cpDatePicker from '@/components/cpDatePicker'

    export default {
        components: {
            mdCaption,
            mdToggleAside,
            mdBtnList,
            cpDatePicker,
        },
        props: {
            sn: {
                require: true
            },
            content: {
                type: Object,
                require: true
            }
        },
        data: function(){
            let $date = new Date(),
                _thisYear = $date.getFullYear(),
                _thisMomth = $date.getMonth() + 1;

            let _y = _thisYear,
                _m = _thisMomth - 1;

            if( _m == 0 ) {
                _y = _y - 1;
                _m = 12;
            }

            let _month = _y +'-'+ this.$okaTool.doubleCount(_m);

            return {
                thisYear: _thisYear,
                thisMomth: _thisMomth,
                month: _month,
            }
        },
        computed: {
            btns: function(){

                return [
                    {
                        text: this.$t('site.func.download'),
                        themes: 'info',
                        func: 'action',
                    },
                    {
                        text: this.$t('site.func.popupclose'),
                        func: 'close',
                    }
                ]
            },
        },
        methods: {
            dayRestriction: function(evt){ //2022-08 ~ 前一個月
                let _result = false;
                
                if( evt.year > 2022 ) {
                    _result = true;
                }else if( evt.year == 2022 ) {

                    if( evt.month >= 8 ) {
                        _result = true;
                    }
                }

                if( evt.year == this.thisYear ) {

                    if( evt.month >= this.thisMomth ) { 
                        _result = false;
                    }
                }

                return _result
            },
            action: function(){

                this.$validator.validate().then(result => {
                    let $content = this.content,
                        $_action = $content.action;

                    $_action(this.month, this.close);
                });
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            },
        }
    }
</script>

<style scoped lang="scss">

</style>
